import { render, staticRenderFns } from "./GpdrWidget.vue?vue&type=template&id=21d0b33f&scoped=true&"
import script from "./GpdrWidget.vue?vue&type=script&lang=js&"
export * from "./GpdrWidget.vue?vue&type=script&lang=js&"
import style0 from "./GpdrWidget.vue?vue&type=style&index=0&id=21d0b33f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d0b33f",
  null
  
)

export default component.exports